import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import ThemeToggle from "@/components/ThemeToggle";
import Logo from "@/components/Logo";

const links = [
  { label: "Services", href: "#services" },
  { label: "Creators", href: "#creators" },
  { label: "Case Studies", href: "#case-studies" },
  { label: "Join Network", href: "#join" },
  { label: "About", href: "#about" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-zinc-950/75 border-b border-white/5"
          : "bg-transparent border-b border-transparent"
      }`}
      data-testid="landing-nav"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 lg:px-10 h-16">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <Logo className="h-8 w-auto" testid="nav-brand-logo" />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-sm text-zinc-400 hover:text-zinc-100 transition-colors"
              data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <ThemeToggle />
          <Link to="/login">
            <Button
              variant="ghost"
              className="text-zinc-300 hover:text-white hover:bg-white/5"
              data-testid="nav-signin-btn"
            >
              Sign in
            </Button>
          </Link>
          <a href="#contact">
            <Button
              className="bg-blue-600 hover:bg-blue-500 text-white rounded-md px-4"
              data-testid="nav-cta-btn"
            >
              Book a Discovery Call
            </Button>
          </a>
        </div>

        <button
          className="md:hidden text-zinc-300"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/5 bg-zinc-950/90 backdrop-blur-xl">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm text-zinc-300 py-1"
              >
                {l.label}
              </a>
            ))}
            <Link to="/login" onClick={() => setOpen(false)} className="text-sm text-zinc-300 py-1">
              Sign in
            </Link>
            <a href="#contact" onClick={() => setOpen(false)}>
              <Button className="w-full bg-blue-600 hover:bg-blue-500 text-white">
                Book a Discovery Call
              </Button>
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
